<template>
    <PublicView>
        <div id="cart-page" class="pt-3" v-if="cate">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <h1 class="mb-2">Giỏ hàng</h1>
                    </div>
                    <div class="col-12">
                        <div id="cart-item-wrap-wrap">
                            <div id="cart-item-wrap">
                                <ProductCartItem v-for="cp in products" :cp="cp" :key="cp._id" />
                            </div>
                        </div>
                    </div>
                    <div class="col-12 pt-4">
                        <button v-on:click="activeForm= true" class="btn" style="background-color: #11a859; color: white">Yêu cầu đơn hàng</button>
                    </div>
                </div>
                <div></div>
                <div></div>
            </div>
            <div id="float-form" v-bind:class="{ active: activeForm }">
                <div class="wrap-form-1">
                    <h1>Đặt hàng</h1>
                    <p>Nhập thông tin của bạn để chúng tôi có thể liên hệ với bạn</p>
                    <div style="position: absolute; top: 22px; right: 26px;" v-on:click="activeForm = false"><i class="fas fa-times"></i></div>
                    <form v-on:submit="submit($event)" method="post" id="form-order">
                        <input v-model="name" type="text" name="name" placeholder="Họ và tên" required pattern="^.{3,}$" />
                        <input v-model="phone" type="text" name="phone" placeholder="Số điện thoại" required pattern="^[0-9\s\.\-\+]{9,}$" />
                        <input v-model="address" type="text" name="address" placeholder="Địa chỉ giao hàng" />
                        <button type="submit">Gửi yêu cầu</button>
                    </form>
                </div>
                
            </div>

        </div>
    </PublicView>
</template>
<script>
import PublicView from "@/components/PublicView.vue";
import ProductCartItem from "@/components/Home/ProductCartItem.vue";
const axios = require("axios").default;
import Swal from 'sweetalert2'
export default {
    name: "DanhMucView",
    data() {
        return {
            totalItems: 0,
            currentPage: 1,
            activeForm: false
        };
    },
    mounted() {
    },
    computed: {
        cart() {
            return this.$store.getters.cart;
        },
        products() {
            return this.cart;
        },
        totalPages() {
            return Math.ceil(this.totalItems / 28);
        },
        cate() {
            return this.$store.getters.cate(this.$route.params.id);
        },
        cateId() {
            return this.$route.params.id;
        }
    },
    watch: {
        cateId() {
            this.currentPage = 1;
        }
    },
    methods: {
        async submit($event) {
            const t = this;
            $event.preventDefault();
            console.log({
                name: this.name,
                phone: this.phone,
                address: this.address,
                cart: this.cart
            })
            axios.post("/api/order", {
                name: this.name,
                phone: this.phone,
                address: this.address,
                cart: this.cart
            }).then((res) => {
                t.activeForm = false;
                if (res.data.success) {
                    Swal.fire("Đặt hàng thành công, chúng tôi sẽ liên hệ với bạn sớm nhất có thể!");
                } else {
                    Swal.fire("Đặt hàng không thành côngcông, vui lòng thử lại sau!");
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        setMetadata(cate) {
            if (cate) {
                let titleTag = document.querySelector("title");
                if (!titleTag) {
                    titleTag = document.createElement("title");
                    document.head.appendChild(titleTag);
                    titleTag = document.querySelector("title");
                }
                titleTag.innerText = cate.info.name + " - alphatech.com.vn";
                let metaTag = document.querySelector("meta[name='title']");
                if (!metaTag) {
                    metaTag = document.createElement("meta");
                    metaTag.setAttribute("name", "title");
                    document.head.appendChild(metaTag);
                    metaTag = document.querySelector("meta[name='title']");
                }
                metaTag.content = cate.info.name + " - alphatech.com.vn";
                let metaTagOg = document.querySelector("meta[property='og:title']");
                if (!metaTagOg) {
                    metaTagOg = document.createElement("meta");
                    metaTagOg.setAttribute("property", "og:title");
                    document.head.appendChild(metaTagOg);
                    metaTagOg = document.querySelector("meta[property='og:title']");
                }
                metaTagOg.content = cate.info.name + " - alphatech.com.vn";




                let metaDescriptionTag = document.querySelector("meta[name='description']");
                if (!metaDescriptionTag) {
                    metaDescriptionTag = document.createElement("meta");
                    metaDescriptionTag.setAttribute("name", "description");
                    document.head.appendChild(metaDescriptionTag);
                    metaDescriptionTag = document.querySelector("meta[name='description']");
                }
                metaDescriptionTag.content = 'Sản phẩm ' + cate.info.name + ' giá tốt nhất thị trường, hỗ trợ kỹ thuật đầy đủ, hậu mãi tận tình';
                let metaDescriptionTagOg = document.querySelector("meta[property='og:description']");
                if (!metaDescriptionTagOg) {
                    metaDescriptionTagOg = document.createElement("meta");
                    metaDescriptionTagOg.setAttribute("property", "og:description");
                    document.head.appendChild(metaDescriptionTagOg);
                    metaDescriptionTagOg = document.querySelector("meta[property='og:description']");
                }
                metaDescriptionTagOg.content = 'Sản phẩm ' + cate.info.name + ' giá tốt nhất thị trường, hỗ trợ kỹ thuật đầy đủ, hậu mãi tận tình';
                if (cate.info.avatar) {
                    let metaImageTagOg = document.querySelector("meta[property='og:image']");
                    if (!metaImageTagOg) {
                        metaImageTagOg = document.createElement("meta");
                        metaImageTagOg.setAttribute("property", "og:image");
                        document.head.appendChild(metaImageTagOg);
                        metaImageTagOg = document.querySelector("meta[property='og:image']");
                    }
                    metaImageTagOg.content = (cate.info.avatar && cate.info.avatar.length > 0 && cate.info.avatar[0] == "/" ? "https://alphatech.com.vn" : "") + cate.info.avatar;
                }



                let metaUrlTag = document.querySelector("meta[property='og:url']");
                if (!metaUrlTag) {
                    metaUrlTag = document.createElement("meta");
                    metaUrlTag.setAttribute("property", "og:url");
                    document.head.appendChild(metaUrlTag);
                    metaUrlTag = document.querySelector("meta[property='og:url']");
                }
                metaUrlTag.content = "https://alphatech.com.vn" + this.$route.path;
                let linkCanonicalTag = document.querySelector("link[rel='canonical']");
                if (!linkCanonicalTag) {
                    linkCanonicalTag = document.createElement("link");
                    linkCanonicalTag.setAttribute("rel", "canonical");
                    document.head.appendChild(linkCanonicalTag);
                    linkCanonicalTag = document.querySelector("link[rel='canonical']");
                }
                linkCanonicalTag.href = "https://alphatech.com.vn" + this.$route.path;
            }

        },
        goToPage(page) {
            this.currentPage = page;
            this.getAllProducts();
        },
        removeVietnameseTones(str) {
            str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
            str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
            str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
            str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
            str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
            str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
            str = str.replace(/đ/g, "d");
            str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
            str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
            str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
            str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
            str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
            str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
            str = str.replace(/Đ/g, "D");
            // Some system encode vietnamese combining accent as individual utf-8 characters
            // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
            str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
            str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
            // Remove extra spaces
            // Bỏ các khoảng trắng liền nhau
            str = str.replace(/ + /g, " ");
            str = str.trim();
            // Remove punctuations
            // Bỏ dấu câu, kí tự đặc biệt
            str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
            return str;
        },
        cateLink(cateObj) {
            return "/danh-muc/" + this.removeVietnameseTones(cateObj.name).replaceAll(" ", "-").toLowerCase() + "/" + cateObj._id;
        },
        price(price) {
            const config = {
                style: 'currency',
                currency: 'VND',
                maximumFractionDigits: 9
            };
            return new Intl.NumberFormat('vi-VN', config).format(price);
        },
    },

    components: {
        PublicView,
        ProductCartItem
    }
};
</script>
<style lang="less">
.swal2-container {
    z-index: 1000000 !important;
}
#cart-page {
    h1 {
        font-size: 30px;
    }
}
#float-form {
    position: fixed;
    top: 0;
    left: -150vw;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100000;
    transition: left 1s ease-in-out;
    &.active {
        left: 0;
    }
    .wrap-form-1 {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: white;
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        width: 400px;
        h1 {
            font-size: 24px;
            margin-bottom: 10px;
        }
        p {
            font-size: 16px;
            margin-bottom: 20px;
        }
        input {
            width: 100%;
            padding: 10px;
            margin-bottom: 10px;
            border-radius: 5px;
            border: 1px solid #ccc;
            font-size: 16px;
        }
        button {
            width: 100%;
            padding: 10px;
            background-color: #11a859;
            color: white;
            border-radius: 5px;
            border: none;
            font-size: 16px;
            cursor: pointer;
        }
    }
}
</style>